import { useInfiniteQuery } from 'react-query';
import { NumberInutilizationRequest } from './numberInutilization.types';
import numberInutilizationServices from './numberInutilization.services';

export const NUMBER_INUTILIZATION_LIST_KEY = 'number-inutilization/list';

export function useNumberInutilizationList(
  params?: NumberInutilizationRequest,
  enabled = true,
) {
  return useInfiniteQuery({
    queryKey: [NUMBER_INUTILIZATION_LIST_KEY, { ...params }],
    queryFn: ({ pageParam }) =>
      numberInutilizationServices.list({ ...params, nextToken: pageParam }),
    getNextPageParam: (lastPage) => lastPage.nextToken,
    enabled,
  });
}
